import { StepItem, Steps } from "../../../shared/components/Steps";
import {
  WSElement,
  WSList,
  WSPanel,
  WSSectionToolbar
} from "@wingspanhq/fe-component-library";
import React from "react";
import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { selectorIsRequirementPostApproval } from "../selectors/selectorIsRequirementPostApproval";
import {
  RequirementReviewStrategy,
  RequirementStatus
} from "@wingspanhq/payments/dist/interfaces/requirement";

export const getRequirementProgressWidget = (
  steps: StepItem[] | undefined,
  requirement: IRequirementResponse,
  showTitle: boolean = true
) => {
  if (!steps?.length) {
    return null;
  }

  let extendedSteps = steps;

  const isPostApprovalFlow = selectorIsRequirementPostApproval(requirement);

  if (requirement.reviewStrategy === RequirementReviewStrategy.AlwaysRequired) {
    const completeStep = steps[steps.length - 1]; // Complete step is always the last step

    // In post-approval flow, we want to inject approval status into the steps before Complete step
    extendedSteps = [
      ...steps.slice(0, -1),
      {
        title: "Approval",
        status:
          requirement.status === RequirementStatus.PendingReview
            ? "Active"
            : isPostApprovalFlow
            ? requirement.status === RequirementStatus.Complete
              ? "Complete"
              : "Rejected"
            : "Pending"
      },
      {
        ...completeStep,
        status: isPostApprovalFlow
          ? requirement.status === RequirementStatus.Complete
            ? "Complete"
            : "Pending"
          : "Pending"
      }
    ];
  } else if (requirement.reviewStrategy === RequirementReviewStrategy.OnFail) {
    const completeStep = steps[steps.length - 1]; // Complete step is always the last step

    // In post-approval flow, we want to inject approval status into the steps before Complete step
    extendedSteps = [
      ...steps.slice(0, -1),
      {
        title: "Approval",
        status:
          requirement.status === RequirementStatus.PendingReview
            ? "Active"
            : requirement.status === RequirementStatus.Complete
            ? "Complete"
            : requirement.status === RequirementStatus.Incomplete &&
              isPostApprovalFlow
            ? "Rejected"
            : "Pending"
      },
      {
        ...completeStep,
        status:
          requirement.status === RequirementStatus.Complete
            ? "Complete"
            : "Pending"
      }
    ];
  }

  return (
    <WSList gap="S">
      {showTitle && <WSSectionToolbar title="Requirement steps" />}
      <WSPanel mt="S">
        <Steps steps={extendedSteps} />
      </WSPanel>
    </WSList>
  );
};
